

import { VideoSettingsData, IFieldDisplayData } from "widgets/commonDataObjects/interfaces"
import { MultiImagesScroller, getItemMargin } from "../../../../commonComponents/base/multiImagesFrontScroller";
import { SiteItemData } from "widgets/interfaces"
import { MultiImagesScrollPerItem } from "../../../../commonComponents/base/multiImagesScrollPerItem";
import { ItemMagazineFront } from "./frontItem";




interface MultiImagesFrontProps {
    itemList: SiteItemData[]
    width: number
    fieldsDisplaySettings: IFieldDisplayData
    videoSettings: VideoSettingsData
    imageWidth: number
    imageHeight: number
    ads_infrastructure_type?: string
}



export class MultiMagazineYplusFront extends React.Component<MultiImagesFrontProps>{
    public static siteScriptName = "MultiImagesMagazineYplusFront";
    public render() {
        const { imageWidth, itemList, imageHeight, videoSettings, fieldsDisplaySettings, width, ads_infrastructure_type } = this.props
        return (
            <MultiImagesScrollPerItem imageWidth={imageWidth} width={width} itemLength={itemList.length} marginRight={20}>
                {itemList.map((slot, index) => {
                    return (
                        <ItemMagazineFront
                            imageWidth={imageWidth}
                            key={index}
                            imageHeight={imageHeight}
                            videoSettings={videoSettings}
                            fieldsDisplaySettings={fieldsDisplaySettings}
                            item={slot}
                            marginLeft={20}
                            ads_infrastructure_type={ads_infrastructure_type}
                        />
                    )
                }
                )}
            </MultiImagesScrollPerItem >)
    }
}